import {
  Box,
  Button,
  Fab,
  Grid,
  InputAdornment,
  Pagination,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import {
  addCategories,
  getItemCategories,
  getItems,
  updateCategories,
} from "./itemCategoriesApi";
import AddCategories from "./addCategories";
import CategoriesCard from "./CategoriesCard";
import Swal from "sweetalert2";
import {
  addCategoriesData,
  getCategories,
  getItemsNames,
  updateCategoriesData,
} from "./itemCategoriesCustomApiHandler";
export default function ItemCategories() {
  const [pagination, setPagination] = useState({ page: 1, total: 1 });
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [itemCategories, setItemCategories] = useState([]);
  const [allItems, setAllItems] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [open, setOpen] = useState(false);
  const getCategoriesKeys = {
    page: 0,
    pageSize: 1000,
    filterByColumn: "",
    filterValue: "",
    searchByColumn: "",
    searchValue: "",
    orderByColumn: "",
    orderBy: "",
  };

  useEffect(() => {
    getCategories(
      getCategoriesKeys,
      getItemCategories,
      setItemCategories,
      setPagination,
      setTotalItems
    );
  }, []);

  useEffect(() => {}, []);

  const handleChange = (event, value) => {
    getCategories(
      { ...getCategoriesKeys, page: value },
      getItemCategories,
      setItemCategories,
      setPagination,
      setTotalItems
    );
    setPagination({
      ...pagination,
      page: value,
    });
  };
  useEffect(() => {
    if (open === false) {
      setSelectedCategories(null);
    }
  }, [open]);
  return (
    <Box sx={{ height: "calc(100vh - 70px)", overflowY: "auto" }}>
      {/* Top Add Category Button */}
      <Grid container spacing={2} alignItems="center">
        {/* Search Field */}
        <Grid item xs={12} sm={8} md={9} lg={10}></Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} sx={{display: 'flex', justifyContent: {xs: 'center', sm: 'flex-end'}}}>
          <Button
            fullWidth
            onClick={() => {
              getItemsNames({ categoryId: 0 }, getItems, setAllItems);
              setOpen(true);
            }}
            sx={{
              textTransform: "capitalize",
              whiteSpace: "nowrap",
              px: 2,
               fontSize: { xs: "12px", sm: "13px", md: "15px" },
              py: { xs: "12px", sm: 1 },

              minWidth: "auto", // keeps button size compact
            }}
            size="medium"
            color="primary"
            variant="contained"
            aria-label="add"
          >
            Add Category
            <AddIcon sx={{ ml: 1 }} />
          </Button>
        </Grid>
      </Grid>
      {/* <Stack
        direction="row"
        spacing={2}
        justifyContent="flex-end"
        sx={{
          position: {
            xs: "fixed",
            sm: "relative",
          },
          top: {
            xs: "65px",
            sm: "0px",
          },
          right: {
            xs: "10px",
            sm: "0px",
          },
          zIndex: 10,
          backgroundColor: {
            xs: "white",
            sm: "transparent",
          },
          px: {
            xs: 1,
            sm: 0,
          },
          py: {
            xs: 1,
            sm: 0,
          },
          width: "auto",
        }}
      >
        
      </Stack> */}

      {/* Table Container - Scrollable on small screens */}
      <Box
        sx={{
          mt: 2,
          backgroundColor: "white",
          borderRadius: "12px",
          p: 1,
          overflowX: "auto",
        }}
      >
        <Box sx={{ minWidth: "100%", width: "100%" }}>
          {/* Header */}
          <Grid
            container
            sx={{
              borderBottom: "1.5px solid black",
              py: {xs:1, sm:2},
              px: { xs: 1, sm: 10, md: 30, lg: 40 },
            }}
          >
            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box sx={{ width: "100%", textAlign: "left", pl: 3 }}>
                <Typography
                  sx={{
                     fontSize: { xs: "12px", sm: "13px", md: "15px" },

                    fontWeight: 500,
                    color: "#01008B",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                >
                  Service Category
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Typography
                align="right"
                sx={{
                   fontSize: { xs: "12px", sm: "13px", md: "15px" },

                  fontWeight: 500,
                  color: "#01008B",
                }}
              >
                No. of Items
              </Typography>
            </Grid>
          </Grid>

          {/* Table Rows */}
          <Box sx={{ maxHeight: "60vh", overflowY: "auto", mt: 1 }}>
            {itemCategories.map((row) => (
              <Grid
                container
                key={row?.id}
                alignItems="center"
                onClick={() => {
                  setSelectedCategories(row);
                  getItemsNames({ categoryId: row?.id }, getItems, setAllItems);
                  setOpen(true);
                }}
                sx={{
                  borderBottom: "1px solid #eee",
                  backgroundColor: "#EEEEFF",
                  borderRadius: "8px",
                  mb: 1,
                  px: { xs: 2, sm: 10, md: 30, lg: 40 },
                  py: 1,
                  cursor: "pointer",
                  boxShadow: 2,
                }}
              >
                <Grid
                  item
                  xs={6}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Box sx={{ width: "100%", textAlign: "left", pl: 3 }}>
                    <Typography
                      sx={{
                        color: "#01008B",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                         fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      {row?.categoryName || "N/A"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    align="right"
                    sx={{
                      color: "#01008B",
                      fontWeight: 500,
                       fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    {row?.size || "N/A"}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Box>
        </Box>
      </Box>

      <AddCategories
        open={open}
        setOpen={setOpen}
        allItems={allItems}
        addCategoriesData={(data) =>
          addCategoriesData(
            data,
            addCategories,
            Swal,
            setSelectedItems,
            getCategoriesKeys,
            getItemCategories,
            setItemCategories,
            setPagination,
            setTotalItems
          )
        }
        section={selectedCategories}
        updateCategoriesData={(data) =>
          updateCategoriesData(
            data,
            updateCategories,
            Swal,
            getCategoriesKeys,
            getCategories,
            getItemCategories,
            setItemCategories,
            setPagination,
            setTotalItems
          )
        }
        setAllItems={setAllItems}
        setSelectedCategories={setSelectedCategories}
        selectedCategories={selectedCategories}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />
    </Box>
  );
}
 {
   /* <Grid container spacing={2} sx={{ mt: 2 }}>
        {itemCategories?.map((item) => {
          return (
            <Grid item lg={2.3} sm={4} xs={12} md={3}>
              <CategoriesCard
                setEditedItem={() => {
                  setSelectedCategories(item);
                  getItemsNames(
                    { categoryId: item?.id },
                    getItems,
                    setAllItems
                  );

                  setOpen(true);
                }}
                item={item}
              />
            </Grid>
          );
        })}
      </Grid> */
 }

 {
   /* <Stack direction="row" justifyContent="space-between" sx={{ mt: 2 }}>
        <Typography color="primary">
          <strong>Total Items: &nbsp;</strong>
          <strong> {totalItems}</strong>
        </Typography>
        <Pagination
          count={pagination.total}
          page={pagination.page}
          onChange={handleChange}
        />
      </Stack> */
 }